import * as React from 'react';
import { connect } from 'react-redux';
import { IEasyQueryQueryModel } from './Parts/EasyQueryUtils';
import * as urls from '../shared/urls';
import './assets/AdvancedSearch.scss';
import { getTableValuesByGroupName } from "../../services/Utils/IndexedDBUtils";
import '@easyquery/enterprise'
import { AdvancedSearchView, EqViewOptions } from '@easyquery/ui';
import 'jquery';
import _ from 'lodash';
import AdvancedSearchHtml from './AdvancedSearchHtml';
import { EqContext } from '@easyquery/core';
import { AuthContext } from '../../services/config/AdalConfig';
import AdalConfig from '../../services/config/AdalEnvConfig';
import Api from '../../services/Api';
import { ApiResponse } from 'apisauce';
import { IAdvancedSearchStore } from '../../common/sharedTypes';
import SelectList from '../RBSelectList/RBSelectList';
import { Form } from 'react-bootstrap';
import { isGranted, permissions } from '../../services/permissionChecker';
import { UserInfo } from '../Login/common/defaults';

const $ = require('jquery');

interface IQueryFunction {
  (query: IEasyQueryQueryModel): void;
}

interface IEasyQueryOwnProps {
  history: any;
  query: string;
}

interface IEasyQueryWidgetFromProps {
  serviceURL: string;
  currentUser: UserInfo;
}

interface IEasyQueryStateLocalState {
  query: IAdvancedSearchStore;
  availableDatabases: { name: string, value: string }[];
  selectedDatabase: string;
}

interface IEasyQueryWidgetFromActions {
}

type IEasyQueryWidgetProps = IEasyQueryWidgetFromActions & IEasyQueryWidgetFromProps & IEasyQueryOwnProps;

export class EasyQueryWidget extends React.Component<IEasyQueryWidgetProps, IEasyQueryStateLocalState> {

  constructor(props) {
    super(props);
    this.state = {
      query: undefined,
      availableDatabases: null,
      selectedDatabase: '',
    };
  }

  context: EqContext = undefined;
  view = new AdvancedSearchView();
  componentDidMount() {
    Api.get("AdvancedSearch/EasyQueryModels").then((response: ApiResponse<any[]>) => {
      const databases = response.data?.map(m => ({ name: m.modelName, value: m.modelId }));
      this.setState({
        availableDatabases: databases,
      });
    })

    const viewOptions: EqViewOptions = {
      serverExporters: ['pdf', 'xlsx', 'csv'],
      loadModelOnStart: true,
      loadQueryOnStart: false,

      handlers: {
        onError: (context, error) => {
          console.error("error:\n" + error.text);
          console.log({ error });
        },
        onListRequest: (params, onResult) => {
          // Check to make sure a list id is passed in
          if (params.listName != null) {
            // Get all the list ids into an array
            let codeListsToGet = params.listName.split(",");
            let numberOfCodeLists = codeListsToGet.length;
            let numberOfCodeListsGathered = 0;
            let codeListToReturn = [];

            // Loop through all the code lists
            codeListsToGet.map(codeListName => {
              numberOfCodeListsGathered++;

              // Get the code list
              getTableValuesByGroupName(codeListName).then(response => {
                codeListToReturn = codeListToReturn.concat(
                  response.map(codeListItem => {
                    return { id: codeListItem.name, text: codeListItem.description };
                  })
                );

                // If it is the last one, add all the code list values to the onResult
                if (numberOfCodeListsGathered >= numberOfCodeLists) {
                  // Sort the list using the sort order and then by text
                  codeListToReturn = _.sortBy(codeListToReturn, ["id", "text"]);
                  onResult(codeListToReturn);
                }
              });

            });
            // Return that all the processing has been completed
            return true;
          }
          // since a list id was not passed in return false
          return false;
        },
        onInit(context) {
          AuthContext.acquireToken(
            AdalConfig.endpoints.api,
            (message, token, msg) => {
              context.getServices().getHttpClient().defaultHeaders['Authorization'] = `Bearer ${token}`
            }
          );
        },
        afterSyncQuery: (context) => {
          if (context.getQuery().isNewbie) return;

          Api.get(`${urls.GET_QUERY}?id=${context.getQuery().getId()}`).then((response: ApiResponse<IAdvancedSearchStore>) => {
            if (this.state.query !== response.data)
              this.setState({
                query: response.data
              })
          }).catch(e => console.error(e))
        },
      },
      widgets: {
        entitiesPanel: {
          showCheckboxes: true
        },
        columnsPanel: {
          allowAggrColumns: true,
          allowCustomExpressions: true,
          attrElementFormat: "{entity} {attr}",
          titleElementFormat: "{attr}",
          showColumnCaptions: true,
          adjustEntitiesMenuHeight: false,
          customExpressionText: 2,
          showPoweredBy: false,
          menuOptions: {
            showSearchBoxAfter: 30,
            activateOnMouseOver: true
          }
        },
        queryPanel: {
          showPoweredBy: false,
          alwaysShowButtonsInGroups: false,
          allowParameterization: true,
          allowInJoinConditions: true,
          autoEditNewCondition: true,
          buttons: {
            condition: ["menu"],
            group: ["addCondition", "addPredicate", "enable", "delete"]
          },
          menuOptions: {
            showSearchBoxAfter: 20,
            activateOnMouseOver: true
          }
        },
        easyGrid: {
          paging: {
            enabled: true,
            pageSize: 30
          }
        }
      },
      result: {
        showChart: false,
      }
    }


    this.view = new AdvancedSearchView();
    this.context = this.view.getContext();
    this.context.useEndpoint(`${this.props.serviceURL}${urls.EASY_QUERY_DEFAULT_API}`);

    const licenseKey: string = process.env.EASYQUERY_LICENSE_KEY || (window as any).easyQueryLicenseKey;
    if (typeof licenseKey === 'string' && licenseKey.trim() !== '') {
      this.context.useEnterprise(licenseKey);
      this.view.init(viewOptions);
    } else {
      // No client-side key configured: load the license from the server (EasyQuery:JSLicenseKey).
      AuthContext.acquireToken(
        AdalConfig.endpoints.api,
        (_message, token) => {
          this.context.getServices().getHttpClient().defaultHeaders['Authorization'] = `Bearer ${token}`;
          this.context.useEnterprise(() => this.view.init(viewOptions));
        }
      );
    }
  }

  componentDidUpdate() {
    this.context = this.view.getContext();
  }

  onChangeDatabase = (event: React.FormEvent<HTMLFormElement>) => {
    const target = event.currentTarget;

    this.setState({ selectedDatabase: target.value });
    this.context.loadModel({ 'modelId': target.value });
  }

  render() {
    const { availableDatabases, selectedDatabase } = this.state;
    const { currentUser } = this.props;

    return (
      <React.Fragment>
        {isGranted(permissions.AdvancedSearchArchivedDatabases, currentUser) &&
          <Form.Group style={{ width: '35%' }}>
            <Form.Label>Database</Form.Label>
            <SelectList
              data={availableDatabases}
              value={selectedDatabase}
              onChange={this.onChangeDatabase}
            />
          </Form.Group>
        }
        <div className="container advancedSearch">
          <AdvancedSearchHtml query={this.state.query} />
        </div>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    serviceURL: state.Application.backendURL,
    currentUser: state.Application.currentUser,
  };
}

export default connect(mapStateToProps)(EasyQueryWidget);
